<template lang="html">

  <section class="carrousel">
    <carousel :data="data" :controls="true" :indicators="false"></carousel>
  </section>

</template>

<script lang="js">
import Vue from 'vue';
import VueCarousel from '@chenfengyuan/vue-carousel';

Vue.component(VueCarousel.name, VueCarousel);
  export default  {
    name: 'carrousel',
    props: [],
    mounted () {

    },
    data() {
      return {
        data: [
          '<div class="fondo" data-fondo="one"></div>',
          '<div class="fondo" data-fondo="two"></div>',
          '<div class="fondo" data-fondo="three"></div>',
          '<div class="fondo" data-fondo="four"></div>',

        ],
      };
        },
    methods: {

    },
    computed: {

    }
}


</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/view-parts/carrousel.vue